import {FormStep} from '../../constants'

export interface GiftCardInputProps {
  mobile: boolean
  currentStep: FormStep
}

export enum GiftCardFormState {
  INITIAL = 'INITIAL',
  EDIT = 'EDIT',
  APPLIED = 'APPLIED',
}
